export default {
  // 首页
  HOME: "/home/init",
  // 测试用接口
  TEST: "/user/test",
  // 价目查询类别
  REFRENCE_PRICE_QUERY_TYPE: "/pricelist/page/init",
  // 价目查询明细
  REFRENCE_PRICE_QUERY_DETAIL: "/pricelist/type",
  // 获取默认卡
  USER_DEFAULT_CARD: "/wx/defaultcard/query",
  // 设置默认卡
  USER_SET_DEFAULT_CARD: "/card/setDefault",
  // 用户基本信息
  USER_BASE_INFO: "/patient/baseInfo",
  // 检验报告列表
  REPORT_INSPECTION_LIST: "/testreport/list/noextract",
  // 检验报告详情
  REPORT_INSPECTION_DETAIL: "/testreport/extract",
  // 医疗影像
  MEDICAL_IMAGING_LIST: "/pacs/query",
  // 医院信息
  REFERENCE_HOSPITAL_INFO: "/hospital/query/param",
  // 注意事项
  REFERENCE_ATTENTIONS_LIST: "/announcements/list",
  // 注意事项明细
  REFERENCE_ATTENTIONS_DETAIL: "/announcements/announcements",
  // 门诊指南
  REFERENCE_OUTPATIENT_GUIDE: "/treatmentguide/list",
  // 健康百科分类
  REFERENCE_HEALTHY_LIST_TYPE: "/article/queryType",
  // 健康百科列表
  REFERENCE_HEALTHY_LIST: "/article/queryList",
  // 健康百科明细
  REFERENCE_HEALTHY_DETAIL: "/article/getArticle",
  // 新闻公告分类
  REFERENCE_NEWS_LIST_TYPE: "/news/getNewsType",
  // 新闻公告列表
  REFERENCE_NEWS_LIST: "/news/queryPage",
  // 新闻公告明细
  REFERENCE_NEWS_DETAIL: "/news/getNews",
  // 门诊清单日期
  REPORT_DAILYLIST_DATE: "/daylist/list",
  // 获取每日清单详情
  REPORT_DAILYLIST_DETAIL: "/charge/record/detail",
  // 获取住院清单详情
  REPORT_INPATIENT_DAILYLIST_DETAIL: "/hospitalized/daylist/detail",
  // 科室介绍列表
  REFERENCE_DEPARTMENT_INTRODUCE_LIST: "/departmentintro/init",
  // 科室介绍明细
  REFERENCE_DEPARTMENT_INTRODUCE_DETAIL: "/departmentintro/department",
  // 关于我没
  REFERENCE_ABOUT_US: "/aboutus//get",
  // 刷新token
  USER_TOKEN_REFRESH: "/user/refreshToken",
  // 卡列表
  USER_CARD_LIST: "/card/queryList",
  // 绑卡
  USER_BIND_CARD: "/card/bind/v2",
  // 绑定手机号
  USER_BIND_PHONE: "/user/bindOpenid",
  // 删除卡片
  USER_DELETE_CARD: "/card/unbind",
  // 获取余额
  // USER_BASE_INFO: "/user/base/info",
  // 科室列表
  APPOINTMENT_DEPARTMENT_LIST: "/appointment/offices",
  // 医生列表
  APPOINTMENT_DOCTOR_LIST: "/appointment/expertsV2",
  // 医生排班
  APPOINTMENT_DOCTOR_SCHEDULE_LIST: "/appointment/experts",
  // 按医生查医生排班
  APPOINTMENT_DOCTOR_SCHEDULE_LIST_DOCTOR: "/appointment/dates",
  // 医生详情
  APPOINTMENT_DOCTOR_DETAIL: "/doctor/info",
  // 预约号源
  APPOINTMENT_SCHEDULE_NUMBERS: "/appointment/times",
  // 登记预约
  APPOINTMENT_REGISTER: "/appointment/register",
  // 用药处方列表
  QUERY_ILLNESS_LIST: "/prescription/query/illnesslist",
  // 用药处方详情
  QUERY_ILLNESS_DETAIL: "/prescription/query/number",
  // 排队叫号
  WAITTING_INLINE_LIST: "/lineup/waitinglist",
  // 排队叫号
  WAITING_LIST: "/lineup/waitinglist",
  // 楼层索引
  FLOORNAV_INIT: "/floornav/init",
  // 楼层详情
  FLOORNAV_FLOOR: "/floornav/floor",
  // 获取图形验证码
  USER_VERIFY_CODE: "/code/getCodePic",
  // 发送短信验证码
  USER_SEND_VERIFY_CODE: "/user/sendSmsForBind",
  // 在线退款-统一查询页面发送短信验证码（非 /rest 路径）
  SEND_VERIFY_CODE: "/refundQueryNew/sendVerificationCode",
  // 在线退款-验证码校验后查询卡列表（非 /rest 路径）
  QUERY_CARD_LIST_BY_SMSCODE: "/refundQueryNew/queryCardListBySmsCode",
  // 查询预约记录
  APPOINTMENT_RECORD: "/appointment/record",
  // 取消预约
  APPOINTMENT_CANCEL: "/appointment/cancel",
  // 获取三码基本信息
  USER_BASE_INFO_QRCODE: "/file/queryhisInfo",
  // 三码建档
  USER_QRCODE_ARCHIVE: "/patient/createfile",
  // 获取三码卡信息
  USER_QRCODE_CARD: "/patient/queryQrInfor",
  // 修改三码信息
  USER_QRCODE_ARCHIVE_MODIFY: "/file/modifyhisInfo",
  // 修改三码验证码
  USER_QRCODE_VARIFY_CODE: "/file/modifyVerificationcode",
  // 查询可绑定卡列表
  CARDS_AVABLE_LIST_QRCODE: "/card/querysmcards",
  // 查询可绑定院内卡列表
  CARDS_AVABLE_LIST_HOSPITAL: "/card/querysmList",
  // 绑定三码卡
  CARDS_BIND_QRCODE: "/card//bindsmCard",
  // 绑卡发送验证码
  CARDS_SEND_CODE: "/card/sendSmsForBind",
  // 医院配置
  HOSPITAL_CONFIG: "/wx/js/config",
  // 满意度调查
  OTHER_SATISFACTION_LIST: "/question/queryOutpatientWaitingDate",
  // 满意度调查问卷
  OTHER_SATISFACTION_QUESTION: "/question/getQuestionnaire",
  // 满意度调查保存
  OTHER_SATISFACTION_QUESTION_SAVE: "/question/saveAnswer",
  // 意见反馈
  FEEDBACK_SAVE: "/feedback/save",
  // 预交金充值下单
  RECHARGE_PAYMENT_COMMIT: "/topup/orderform/add",
  // 充值记录
  RECHARGE_PAYMENT_RECORDS: "/topup/record/allchannel",
  // 获取药品制剂列表
  OTHER_DRUG_INTRUCTION_LIST: "/drug/query",
  // 获取药品制剂明细
  OTHER_DRUG_INTRUCTION_DETAIL: "/drug/get",
  // 门诊结算跳转判断
  INPATIENT_SETTLEMENT_CONFIRM: "/settle/pre",
  // // 获取每日清单日期列表
  // REPORT_DAILYLIST_DATE: "/report/dailylist/date",
  // // 获取每日清单详情
  // REPORT_DAILYLIST_DETAIL: "/report/dailylist/detail",
  // 核酸检测职业
  TEST_NUCLEIC_ACID_PROFESSION: "/ncp/profession",
  // 核酸开单提交
  TEST_NUCLEIC_ACID_COMMIT: "/ncp/register",
  // 核酸开单个人信息
  TEST_NUCLEIC_ACID_USERINFO: "/patient/queryBrQrInfo",
  // 核酸开单查询是否建档
  TEST_IS_JD: "/hs/isjd",
  // 核酸开单建档
  TEST_CREAT_FILE: "/hs/createFile",
  // 核酸开单重新开单
  TEST_REOPEN: "/hs/reOpen",
  // 核酸开单获取卡列表
  TEST_CARD_LIST: "/hs/cardno",
  // 核酸开单获取报告列表
  TEST_GET_QUERY: "/hs/query",
  // 核酸开单手动查询列表
  TEST_GET_MANUAL_LIST: "/hs/queyCardno",
  // 核酸开单获取个人基本信息
  TEST_GET_PATIENT: "/hs/getPatient",
  // 核酸开单获取职业
  TEST_GET_PROFESSION: "/hs/profession",
  // 核酸开单获取采集点
  TEST_GET_CJD: "/hs/cjd",
  // 核酸开单下单
  TEST_ADD_ORDER: "/hs/addOrder",
  // 核酸开单报告查询
  TEST_GET_BGCX: "/hs/bgcx",
  // 体检报告列表
  MES_REPORT_LIST: "/mes/getReportList",
  // 体检报告详情
  MES_REPORT_DETAIL: "/mes/getReportDetail",
  // 疫苗获取可预约日期
  VAC_GATDATE: "/vac/getDate.json",
  // 疫苗获取可预约数
  VAC_GET_QTY: "/vac/getQty.json",
  // 疫苗预约登记
  VAC_REG: "/vac/reg.json",
  // 疫苗预约记录
  VAC_CONSULT: "/vac/consult.json",
  // 疫苗取消预约
  VAC_CANCEL: "/vac/cancel.json",
  // 核酸开单查询
  TEST_PATIENT_BYID: "/patient/byId.json",
  // 核酸开单查询列表
  TEST_REPORT_LIST: "testreport/list/noextract",
  // 核酸开单获取个人信息
  TEST_GET_BASEINFO: "/patient/baseInfo",
  // 核酸开单获取报告详情
  TEST_GET_REPORT_DETAIL: "/testreport/extract",
  // 获取订单号
  GET_ORDER_FORMNO: "topup/getOrderFormNo",
  GET_HS_ORDER_AMOUNT: "hs/getHsOrderAmount",
  //推送设置
  //获取列表
  PUSH_GET_LIST: "/push/getList",
  //新增设置
  PUSH_ADD_SET: "/push/pushSet",
  //删除设置
  PUSH_DELETE: "/push/delete",
  //立即推送
  PUSH_PUSH: "/push/push",
  //登录
  PUSH_LOGIN: "/push/login",
  //获取图形验证码
  PUSH_GET_PICCODE: "/code/getCodePic",
  //获取短信验证码
  PUSH_GET_PHONECODE: "/user/sendSmsForBind",
  //获取推送信息
  PUSH_GET_INFO: "/push/getInfo",
  //推送测试
  TEST_PUSH: "/push/testPush",
  /*住院电子陪护凭证*/
  //陪护列表
  ESCORTPEOPLE_LIST: "escortPeople/getList",
  //添加陪护人员
  ESCORTPEOPLE_ADD: "escortPeople/addEscortPeople",
  //修改陪护人员
  ESCORTPEOPLE_UPDATE: "escortPeople/updateEscortPeople",
  //陪护发送验证码
  ESCORTPEOPLE_SENMSG: "escortPeople/sendSmsForEscort",
  //启动陪护
  ESCORTPEOPLE_START: "escortPeople/startEscort",
  //停止陪护
  ESCORTPEOPLE_STOP: "escortPeople/stopEscort",
  //核酸检测文件上传
  ESCORTPEOPLE_UPLOAD: "escortPeople/upLoadFile",
  //删除陪护
  ESCORTPEOPLE_DEL: "escortPeople/delEscort",
  //获取院内核酸检测结果
  ESCORTPEOPLE_GETRECORD: "escortPeople/getRecord",
  //添加承诺函
  ESCORTPEOPLE_ADDSURVEY: "escortPeople/addSurvey",
  //添加承诺函
  ESCORTPEOPLE_CARD_LIST: "escortPeople/getCardListByOpenId",
  // 获取失信人员名单
  MEDICAL_INSURANCE_QUERY: "MedicalInsurance/query",
  // 停诊通知
  SUBSPEND_DOCTORLIST: "subspend/doctorList",
  // 在线退款信息
  REFUNDPATIENT_BASEINFO: "refundPatient/base-info"
};
